// This is for expanded collapsible tabs on pages. It uses the General Information Section > Collapsible Tabs

(function () {
  // Prevent multiple initializations
  if (window.pageCollapTabInitialized) {
    return;
  }
  window.pageCollapTabInitialized = true;

  document.addEventListener("DOMContentLoaded", function () {
    document
      .querySelectorAll(".info-collap-tab-btn")
      .forEach(function (tabBtn) {
        // Check if this button already has an event listener
        if (tabBtn.hasAttribute("data-collap-initialized")) {
          return;
        }
        tabBtn.setAttribute("data-collap-initialized", "true");

        tabBtn.addEventListener("click", function () {
          const isExpanded = this.getAttribute("aria-expanded") === "true";
          this.setAttribute("aria-expanded", !isExpanded);

          const content = this.nextElementSibling;
          content.classList.toggle("visible-info");
        });
      });
  });
})();
